import Footer from './components/footer';
import Nav from './components/nav';
import Main from './pages/main';
import OurCommunity from './pages/ourCommunity';
import AboutUs from './pages/aboutus';
import Faq from './pages/faq';
import BusinessPlan from './pages/businessPlan';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from './pages/protectedRoute';
import Signin from './pages/signin';
import Signup from './pages/Signup';
import Termas from './pages/termas';
import Parivacy from './pages/parivacy';
import ForgotPassword from './pages/forgotPassword';
import WithdrawalReqRes from './pages/WithdrawalReqRes';
import Topup from './pages/Topup';
import DirectWithdrawal from './pages/DirectWithdrawal';

function App() {

  return (
    <div className="App">
      <div>
        
        <Routes>
        <Route index element={<Navigate to="/app/home" replace />} />
        
          <Route path='app' element={<ProtectedRoute/>}>
            <Route path='home' element={<Main />} />
            <Route path='ourcommunity' element={<OurCommunity />} />
            <Route path='aboutus' element={<AboutUs />} />
            <Route path='faq' element={<Faq />} />
            <Route path='business-plan' element={<BusinessPlan />} />
          </Route>
          <Route path='/signin' element={<Signin/>} />
          <Route path='/signup' element={<Signup/>} />
          <Route path='/termas' element={<Termas/>}/>
          <Route path='/parivacy' element={<Parivacy/>}/>
          <Route path='/transaction' element={<WithdrawalReqRes />}/>
          <Route path='/reinvestment' element={<Topup />}/>
          <Route path='/payment' element={<DirectWithdrawal />}/>
          <Route path='/forgotpassword' element={<ForgotPassword/>}/>
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default App;
